import React, { useEffect } from "react";
import { IOffer } from "./header/OfferBanner";
import { cn } from "@/lib/utils";
interface IBodyProps {
  offer: IOffer;
  children: React.ReactNode;
  emergencyActive: boolean;
  isShowGotoPass: boolean;
  pathname: string;
  onLoaded?: () => void;
  addMarginClasses?: boolean;
}

/**
 * Body component
 * Handles main page body layout and adjusts margin based on offer, emergency, and route.
 * Triggers onLoaded callback when mounted.
 */
export default function Body(props: Readonly<IBodyProps>) {
  const {
    offer,
    children,
    emergencyActive,
    isShowGotoPass,
    pathname,
    onLoaded,
    addMarginClasses=true
  } = props;
  useEffect(() => {
    // Call onLoaded callback after mount
    onLoaded?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let marginTopClass = addMarginClasses ? "mt-[var(--header-height)]" : "";

  if (!pathname.includes("/premier-residence")) {
    if (((offer.title && isShowGotoPass) || emergencyActive) && addMarginClasses) {
      marginTopClass =
        "mt-[calc(var(--header-height)+var(--mobile-offer-height))] md:mt-[calc(var(--header-height)+var(--offer-height))]";
    }
  }
  return <div className={cn(marginTopClass, addMarginClasses && "min-h-[400px]")}>{children}</div>;
}
